import API from "@/global/request/api";
import axios from "@/global/request/axios";

export default {
  districts() {
    const cache = localStorage.getItem("district");
    if (!cache) {
      return axios.get(API.districts).then(res => {
        res.forEach(data => {
          if (data.children) {
            let a = {
              value: 0,
              label: "其他地区",
              children: []
            };
            data.children.push(a);
            data.children.forEach(item => {
              item.children = item.children ? item.children : [];
              let b = {
                value: 0,
                label: "其他地区"
              };
              item.children.push(b);
            });
          }
        });
        localStorage.setItem("districts", JSON.stringify(res));
        return res;
      });
    }
    const districts = JSON.parse(cache);
    return Promise.resolve(districts);
  },
  school() {
    return axios.get(API.school);
  },
  subject() {
    return axios.get(API.subject);
  },
  grades() {
    return axios.get(API.grades);
  }
};
